<div>
	<nb-route-tabset [tabs]="tabs" fullWidth></nb-route-tabset>
	<nb-spinner *ngIf="loading"> </nb-spinner>
</div>
